import { render, staticRenderFns } from "./Account.vue?vue&type=template&id=6d0444a6"
import script from "./Account.vue?vue&type=script&lang=js"
export * from "./Account.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d0444a6')) {
      api.createRecord('6d0444a6', component.options)
    } else {
      api.reload('6d0444a6', component.options)
    }
    module.hot.accept("./Account.vue?vue&type=template&id=6d0444a6", function () {
      api.rerender('6d0444a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Account.vue"
export default component.exports